import * as QuestionnaireApi from '@/api/Questionnaire'

export default function useChat() {
  const questionnaireDeliverUserList = async (payload) => {
    const res = await QuestionnaireApi.questionnaireDeliverUserList(payload)
    return res
  }

  const questionnaireDeliver = async (payload) => {
    const res = await QuestionnaireApi.questionnaireDeliver(payload)
    return res
  }

  const questionnaireDeliverList = async (payload) => {
    const res = await QuestionnaireApi.questionnaireDeliverList(payload)
    return res
  }

  const questionnairePartCopy = async (payload) => {
    const res = await QuestionnaireApi.questionnairePartCopy(payload)
    return res
  }

  const questionnairePartItemsEdit = async (payload) => {
    const res = await QuestionnaireApi.questionnairePartItemsEdit(payload)
    return res
  }

  const questionnairePartInfo = async (payload) => {
    const res = await QuestionnaireApi.questionnairePartInfo(payload)
    return res
  }

  const questionnaireList = async (payload) => {
    const res = await QuestionnaireApi.questionnaireList(payload)
    return res
  }

  const questionnairePartList = async (payload) => {
    const res = await QuestionnaireApi.questionnairePartList(payload)
    return res
  }

  const getFormList = async (payload) => {
    const res = await QuestionnaireApi.getFormList(payload)
    return res
  }
  const editFormList = async (payload) => {
    const res = await QuestionnaireApi.editFormList(payload)
    return res
  }
  const getFillInList = async (payload) => {
    const res = await QuestionnaireApi.getFillInList(payload)
    return res
  }
  const getFillInInfo = async (payload) => {
    const res = await QuestionnaireApi.getFillInInfo(payload)
    return res
  }
  const createQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.createQuestionnaire(payload)
    return res
  }
  const editPartQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.editPartQuestionnaire(payload)
    return res
  }
  const editQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.editQuestionnaire(payload)
    return res
  }
  const publishQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.publishQuestionnaire(payload)
    return res
  }
  const deleteQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.deleteQuestionnaire(payload)
    return res
  }
  const archiveQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.archiveQuestionnaire(payload)
    return res
  }
  const getQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.getQuestionnaire(payload)
    return res
  }
  const uploadImage = async (payload) => {
    const res = await QuestionnaireApi.uploadImage(payload)
    return res
  }
  const getFillInData = async (payload) => {
    const res = await QuestionnaireApi.getFillInData(payload)
    return res
  }
  const editFillIn = async (payload) => {
    const res = await QuestionnaireApi.editFillIn(payload)
    return res
  }
  const getReportList = async (payload) => {
    const res = await QuestionnaireApi.getReportList(payload)
    return res
  }
  const copyQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.copyQuestionnaire(payload)
    return res
  }
  const downloadQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.downloadQuestionnaire(payload)
    return res
  }
  const deleteFormList = async (payload) => {
    const res = await QuestionnaireApi.deleteFormList(payload)
    return res
  }
  const deleteResult = async (payload) => {
    const res = await QuestionnaireApi.deleteResult(payload)
    return res
  }

  return {
    questionnaireDeliverUserList,
    questionnaireDeliverList,
    questionnaireDeliver,
    questionnairePartCopy,
    questionnairePartList,
    questionnaireList,
    getQuestionnaire,
    questionnairePartInfo,
    questionnairePartItemsEdit,

    getFormList,
    editFormList,
    getFillInList,
    createQuestionnaire,
    editQuestionnaire,
    deleteQuestionnaire,
    archiveQuestionnaire,

    editPartQuestionnaire,
    uploadImage,
    getFillInData,
    publishQuestionnaire,
    editFillIn,
    getReportList,
    copyQuestionnaire,
    downloadQuestionnaire,
    deleteFormList,
    deleteResult,
    getFillInInfo,
  }
}
